import { Div, Link, Span } from "@tblabs/truffle";
import { Product } from "../../../Models/Product/Product";


export class ProductBreadcrumbs extends Div
{
    constructor(product: Product)
    {
        super("product-breadcrumbs");

        this.Append(
            new Link("Oferta", "#kategorie-produktow").Class("product__breadcrumbs-link"),
            new Span("›").Class("product-breadcrumbs__separator"),
            new Link(product.Category.Title.value, "#kategoria/" + product.Category.Url.value).Class("product__breadcrumbs-link"),
            // new Span("›").Class("product-breadcrumbs__separator"),
            // new Text(product.Title).Class("product__breadcrumbs-current")
        );
    }
}
